// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Moves the dragged folder to the position of the folder it was dropped on: dragging forward lands
// after the target, dragging backward lands before it. Returns the same array when nothing moves,
// so callers can skip a dispatch.
const moveFolder = (folders: IFolder[], activeId: string, overId: string): IFolder[] => {
  if (activeId === overId) return folders;
  const from = folders.findIndex((folder) => folder._id === activeId);
  const to = folders.findIndex((folder) => folder._id === overId);
  if (from === -1 || to === -1) return folders;
  const moved = [...folders];
  const [active] = moved.splice(from, 1);
  moved.splice(to, 0, active);
  return moved;
};

export default moveFolder;
